import { TechnicalViewContainer } from 'src/containers/SoftwareEscrow/Technical';

const SettingsTechnical = () => {
  return <TechnicalViewContainer />;
};

export default SettingsTechnical;
